import "./style.scss";

export default (props) => {
    const isCover = props.cover?true:false;

    if(isCover){
        return <div className="loader-cover"><div className="loader-cdm" ></div></div>
    }

    return <div className="loader-cdm" ></div>
}